module.exports = __webpack_public_path__ + "img/ru_Ecran 1.87169d11.png";